export default __webpack_public_path__ + "static/media/crossroadsremoved.65e37b68.png";